import {
  FormCard,
  FormCardBlock,
  FormCardLeftColumn,
  FormCardRightColumn,
  FormCardRow,
} from "@/components/ux/form.card"
import { useUser, useUserActions } from "@/api/users"
import { Button } from "@/components/ui/button"
import { format } from "date-fns"

export default function AccountDeleteForm() {
  const { update, scheduleDeletion } = useUserActions()
  const { user } = useUser()

  if (!user) return null

  const onRequestDelete = async () => {
    await scheduleDeletion()
  }

  const onCancelDelete = async () => {
    await update({ scheduledDeletion: null })
  }

  return (
    <FormCard title="Delete account">
      <FormCardBlock>
        <FormCardRow>
          <FormCardLeftColumn>
            You can request to delete your account. It will be deleted 30 days
            after your request.
          </FormCardLeftColumn>
          <FormCardRightColumn>
            {user.scheduledDeletion ? (
              <div className="flex flex-col gap-4">
                <p className="text-sm">
                  Your account is scheduled for deletion on{" "}
                  {format(user.scheduledDeletion, "MMM do, yyyy")}
                </p>
                <Button
                  type="button"
                  variant="outline"
                  onClick={onCancelDelete}
                >
                  Cancel deletion
                </Button>
              </div>
            ) : (
              <Button
                type="button"
                variant="destructive"
                onClick={onRequestDelete}
              >
                Delete account
              </Button>
            )}
          </FormCardRightColumn>
        </FormCardRow>
      </FormCardBlock>
    </FormCard>
  )
}
